/* tslint:disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import {
  notificationsGet,
  NotificationsGetParams,
} from '../fn/notification/notifications-get';
import {
  notificationReadPut,
  NotificationReadPutParams,
} from '../fn/notification/notification-read-put';
import { notificationsReadAllPut } from '../fn/notification/notifications-read-all-put';
import { notificationPreferencesGet } from '../fn/notification/notification-preferences-get';
import {
  notificationPreferencesPut,
  NotificationPreferencesPutParams,
} from '../fn/notification/notification-preferences-put';
import { PaginatedList } from '../models/paginator/paginated-list';
import { NotificationModel } from '../models/notification-model';
import { NotificationPreferencesModel } from '../models/notification-preferences-model';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  notificationsGet$Response(
    params: NotificationsGetParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PaginatedList<NotificationModel>>> {
    return notificationsGet(this.http, this.rootUrl, params, headers, context);
  }

  notificationsGet(
    params: NotificationsGetParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<PaginatedList<NotificationModel>> {
    return this.notificationsGet$Response(params, headers, context).pipe(
      map(
        (
          r: StrictHttpResponse<PaginatedList<NotificationModel>>,
        ): PaginatedList<NotificationModel> => r.body,
      ),
    );
  }

  notificationReadPut$Response(
    params: NotificationReadPutParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    return notificationReadPut(
      this.http,
      this.rootUrl,
      params,
      headers,
      context,
    );
  }

  notificationReadPut(
    params: NotificationReadPutParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<void> {
    return this.notificationReadPut$Response(params, headers, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body),
    );
  }

  notificationsReadAllPut$Response(
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    return notificationsReadAllPut(this.http, this.rootUrl, headers, context);
  }

  notificationsReadAllPut(
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<void> {
    return this.notificationsReadAllPut$Response(headers, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body),
    );
  }

  notificationPreferencesGet$Response(
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<NotificationPreferencesModel>> {
    return notificationPreferencesGet(
      this.http,
      this.rootUrl,
      headers,
      context,
    );
  }

  notificationPreferencesGet(
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<NotificationPreferencesModel> {
    return this.notificationPreferencesGet$Response(headers, context).pipe(
      map(
        (
          r: StrictHttpResponse<NotificationPreferencesModel>,
        ): NotificationPreferencesModel => r.body,
      ),
    );
  }

  notificationPreferencesPut$Response(
    params: NotificationPreferencesPutParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<NotificationPreferencesModel>> {
    return notificationPreferencesPut(
      this.http,
      this.rootUrl,
      params,
      headers,
      context,
    );
  }

  notificationPreferencesPut(
    params: NotificationPreferencesPutParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<NotificationPreferencesModel> {
    return this.notificationPreferencesPut$Response(
      params,
      headers,
      context,
    ).pipe(
      map(
        (
          r: StrictHttpResponse<NotificationPreferencesModel>,
        ): NotificationPreferencesModel => r.body,
      ),
    );
  }
}
